// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ideal-postcodes-autocomplete-wrapper[data-v-148f06fa]{position:relative}.ideal-postcodes-autocomplete-suggestions[data-v-148f06fa]{background:#fff;border:1px solid #c3c9cb;list-style:none;margin:0;max-height:50vh;overflow:scroll;padding:.5rem 0;position:absolute;width:100%;z-index:999}.ideal-postcodes-autocomplete-suggestion[data-v-148f06fa]{cursor:pointer;padding:.125rem 1rem}.ideal-postcodes-autocomplete-suggestion[data-v-148f06fa]:hover{background:#e5e5e5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
